import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col, Card, Form, Button } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import AutocompletePlaceholder from 'views/interface/forms/controls/autocomplete/AutocompletePlaceholder';
import DropzoneColumns from 'views/settings/components/DropzoneColumns';
import { BusinessBaseModel, BusinessModel, BusinessTypeModel, IndustryStyleTypeModel, StateModel } from 'API/Generated/data-contracts';
import { Businesses } from 'API/Generated/Businesses';
import { observer } from 'mobx-react';
import * as Yup from 'yup';
import { useFormik, useFormikContext } from 'formik';
import ImageUpload from 'views/components/ImageUpload';
import { Geography } from 'API/Generated/Geography';
import Select from 'react-select';
import { GetGeoStore } from 'SessionState/Geo/GeoStore';
import MultiSelect from 'components/forms/MultiSelect';
import { GetBusinessStore } from 'SessionState/Business/BusinessStore';
import { BetaWrapper } from 'views/default/BetaWrapper';
// import { IBusinessValues } from './AddEditBusinessModal';

export interface IAddEditBusinessFormProps {
  businessModel?: BusinessModel | null;
  business?: BusinessBaseModel;
  businessIndex: number;
}

const AddEditBusinessForm = (observer((props: IAddEditBusinessFormProps) => {
  const businessStore = GetBusinessStore();
  const geoStore = GetGeoStore();

  const init = async () => {
    // let res = await geographyService.getStates();
    await geoStore.getStates();
  }
  useEffect(() => {
    businessStore.getAllBusinessTypes();
    init();
  }, []);

  const businessTypeOptions = useMemo(() => {
    return businessStore.BusinessTypes?.map((item) => {
      return { value: item.id, label: item.name };
    });
  }, [businessStore.BusinessTypes]);

  const [allStates, setAllStates] = useState<StateModel[]>([]);
  const [allIndustryTypes, setAllIndustryTypes] = useState</*IndustryStyleType[]*/ any[]>([]);
  const [allIndustryOptions, setAllIndustryOptions] = useState</*IndustryStyleType[]*/ any[]>([]);
  const [resultMessage, setResultMessage] = useState<string | null | undefined>(null);
  const stateOptions = geoStore.StateList.map(x => { return { value: x.id,   label: `${x.name} (${x.abbreviation})`, } })


  const otherValidationSchema = Yup.object().shape({
    name: Yup.string().required(),
    startDate: Yup.string(),
    website: Yup.string(),
    stateId: Yup.number().required('State is required'),
    isActive: Yup.boolean().isTrue(),
    about: Yup.string().max(255, 'About must be 255 characters or less.'),
  });

  const onSubmit = (values) => console.log('submit form', values);
  const validationSchema = otherValidationSchema;
  const { handleSubmit, handleChange, values, touched, errors } = useFormikContext<BusinessBaseModel>();
  return (
    <>
      {/* Business Add/Edit Form Start */}
      <Form>
        <Card>
          <Card.Body className="mb-n5">
            <div className="d-flex align-items-center flex-column">
              <div className="position-relative mb-3">
                <h2 className="small-title text-center">Upload Logo/Image</h2>
                <ImageUpload image={values.businessLogo?.image || undefined} containerName='business-images' />
                {/* <ImageUpload image={values.businessLogo?.image} /> */}
              </div>
            </div>
            <div className="mb-3 top-label">
              <Form.Control type="text" placeholder="Business Name" name="name" onChange={handleChange} value={values.name ?? ''} />
              <Form.Label>Business Name</Form.Label>
              {errors.name && touched.name && <div className="d-block invalid-tooltip">{`${errors.name}`}</div>}
            </div>
            <Row className="mb-7">
              <Col md="6">
                <div className="mb-3 top-label">
                  <Select
                    classNamePrefix="react-select"
                    options={businessTypeOptions}
                    isMulti={false}
                    value={businessTypeOptions?.find((obj) => obj.value === values.businessTypeId)}
                    onChange={(selectedOption) => {
                      let event = { target: { name: "type", value: businessStore.BusinessTypes.find(x => x.id = selectedOption?.value) } }
                      handleChange(event)
                    }}
                  />
                  <Form.Label>Business Type</Form.Label>
                  {/* {errors.type && touched.type && <div className="d-block invalid-tooltip">{`${errors.type}`}</div>} */}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3 top-label">
                  <Form.Control type="date" placeholder="Year Began Pageants" onChange={handleChange} name="startDate" value={values.startDate ?? ''} />
                  <Form.Label>Business Start Date</Form.Label>
                  {errors.startDate && touched.startDate && <div className="d-block invalid-tooltip">{`${errors.startDate}`}</div>}
                </div>
              </Col>
              <Col>
                <div>
                  <Form.Check
                    type="checkbox"
                    label="This business is active"
                    value="Active"
                    checked={!!values.isActive}
                    id="isActive"
                    name="isActive"
                    onChange={handleChange}

                  />

                </div>
              </Col>
              <Form.Label>Business Home Location</Form.Label>
              <Col md="6">
                <div className="mb-3 top-label">
                  <Form.Control type="text" placeholder="City" onChange={handleChange} name="city" value={values.city ?? ''} />
                  <label className="form-label text-danger">CITY <span className='text-danger'>*</span></label>
                  {errors.city && touched.city && <div className="d-block invalid-tooltip">{`${errors.city}`}</div>}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3 top-label">
                  <label className="form-label text-danger">STATE <span className='text-danger'>*</span></label>
                  <Select
                    classNamePrefix="react-select"
                    value={stateOptions.find((x) => x.value == values.stateId)}
                    options={stateOptions}
                    onChange={(selectedOption) => {
                      let event = { target: { name: 'stateId', value: selectedOption?.value } };
                      handleChange(event);
                    }}
                  />

                </div>
              </Col>
            </Row>
            <Row>
              <div className="mb-3 top-label">
                <Form.Control type="text" placeholder="business website" name="website" onChange={handleChange} value={values.website ?? ''} />
                <Form.Label>Website</Form.Label>
                {errors.website && touched.website && <div className="d-block invalid-tooltip">{`${errors.website}`}</div>}
              </div>
              <div className="mb-3 top-label">
                <Form.Control as="textarea" rows={3} placeholder="A little bit about the business" name="about" onChange={handleChange} value={values.about ?? ''} />
                <Form.Label>About</Form.Label>
                {errors.about && touched.about && <div className="d-block invalid-tooltip">{`${errors.about}`}</div>}
              </div>

            </Row>

          </Card.Body>
        </Card>
      </Form>
      {/* Business Add/Edit Form End */}
    </>
  );
}));

export default AddEditBusinessForm;
